function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            //toggleActions:'play none none reverse',
        }
    })
}

var wFlag=window.innerWidth>750

$(()=>{
    setTimeout(() => {
        $('.box1_title').fadeIn(1000)
    }, 300);

    //box2
    gsap.registerPlugin(SplitText)
    SplitText.create(".box2_title", {
        type: "words",
        autoSplit: true,
        wordsClass:"word++",
        onSplit(self) {
            return gsap.from(self.words, {y: 150,opacity: 0,ease: "power4",stagger: 0.04,
                scrollTrigger:{
                    trigger:'.box2_title',
                    start:'top bottom-=20%',
                    end:'+=50%',
                    scrub:1,
                }
            });
        }
    });
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top+=10% top+=6%',
            end:'+=30%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
            .from('.box2_title',{y:'4rem',scale:2.2,color:'black',duration:0.5})
            .from('.box2_text',{y:'2rem',opacity:0})
        })

        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=6%',
            end:'+=50%',
            pin:true,
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=6%',
            end:'+=30%',
            pin:true,
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
            .to('.box2_title',{opacity:0,duration:0.5})
            .from('.box2_text',{y:'2rem',opacity:0})
        })
    }

    //box3
    showUp('.box3_title')
    showUp('.box3Swiper')
    if(wFlag){
        $('.box3Swiper .swiper-slide').hover(function(){
            $(this).addClass('box3Active').siblings().removeClass('box3Active')
        })
    }else{
        new Swiper('.box3Swiper', {
            pagination: {
                el: '.box3Swiper-pagination',
            }
        })
        $('.box4_nav div').click(function(){
            var index = $(this).index()
            $(this).addClass('box4Active').siblings().removeClass('box4Active')
            $('.box4_items div').eq(index).addClass('block').siblings().removeClass('block')
        })
    }

    showUp('.box4_title')
    showUp('.box4_item')


})


var box2SwiperInstance = null

new Vue({
    el:'.box2',
    data(){
        return{
            navIndex:0,
            childIndex:0,
            lastIndex:0,
            selectData:[
                {
                    title:'What kind of user are you?',
                    item:[
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/9_930dc3b4-c1e7-4951-afd8-2b79dd0a17d3.png?v=1773196034',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/9_47c1c722-c268-444c-8905-e021fb0f0433.png?v=1773196040',
                            text:'Beginner<span>New to vaping</span>',
                            active:false
                        },
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/8_646840b3-35c0-4858-b3da-6eb591dd8505.png?v=1773196034',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/8_d65de5a7-56b0-4671-af87-38f6f5d80f2d.png?v=1773196040',
                            text:"Explorers<span>I've tried a few devices</span>",
                            active:false
                        }
                    ]
                },
                {
                    title:'Choose Your Budget Range',
                    item:[
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/6_19a722c8-48a1-4164-bc6f-7c115b888b0d.avif?v=1773310939',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/6_93c52b76-de5f-4411-9a41-373b1bdd1753.png?v=1773310962',
                            text:'Entry-Level',
                            active:false
                        },
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/7_8f5a6b20-dd92-4409-9e20-bbdbb598b638.avif?v=1773310939',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/7_83b12f52-7b7f-4e32-b5ce-0094b46834bc.png?v=1773310962',
                            text:'Mid-Range',
                            active:false
                        },
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/5_bd1cc388-7afb-4fa5-961d-7b3d2608bdf5.avif?v=1773310939',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/5_405e42c5-1f8e-46a2-bc23-159717cd1cb9.png?v=1773310962',
                            text:'Premium',
                            active:false
                        }
                    ]
                },
                {
                    title:'What fits your needs best?',
                    item:[
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1.1.png?v=1790740582',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_96c8eca3-9701-4679-85f9-8d7d279708ce.png?v=1790740582',
                            text:'Everyday Use<br> & Versatile',
                            active:false,
                            childItem:{
                                title:'What matters most to you?',
                                item:[
                                    {
                                        text:'All-Round<br> Performance',
                                        active:false
                                    },
                                    {
                                        text:'Anti-Burn<br> Protection',
                                        active:false
                                    },
                                    {
                                        text:'Simple<br> Power Control',
                                        active:false
                                    },
                                    {
                                        text:'Touchscreen<br> Experience',
                                        active:false
                                    },
                                    {
                                        text:'Anti-Burn &<br> Flavor Replay',
                                        active:false
                                    },
                                    {
                                        text:'Large<br> Cartridge<br> Capacity',
                                        active:false
                                    }
                                ]
                            }
                        },
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2.1.png?v=1790740582',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_a3fe02d6-c0e3-4f3a-8793-b8609c36eefd.png?v=1790740582',
                            text:'Easy<br> & Affordable',
                            active:false,
                            childItem:{
                                title:'What matters most to you?',
                                item:[
                                    {
                                        text:'Simple<br> & Reliable',
                                        active:false
                                    },
                                    {
                                        text:'Best<br> for Beginners',
                                        active:false
                                    },
                                    {
                                        text:'Long-Lasting<br> Battery',
                                        active:false
                                    },
                                    {
                                        text:'Metal Body<br> & Lightweight',
                                        active:false
                                    },
                                    {
                                        text:'Slim &<br> Cig-Like Mouthpiece',
                                        active:false
                                    }
                                ]
                            }
                        },
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3.1.png?v=1790740582',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_366899ec-0db6-4eec-9d4d-e672dce3d61a.png?v=1790740582',
                            text:'Power & Performance',
                            active:false,
                            childItem:{
                                title:'What matters most to you?',
                                item:[
                                    {
                                        text:'Smooth & Powerful',
                                        active:false
                                    },
                                    {
                                        text:'Big Clouds & DTL',
                                        active:false
                                    }
                                ]
                            }
                        },
                        {
                            img1:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4.1.png?v=1790740582',
                            img2:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4_290633ee-cbb2-4629-a55d-8d68f7eada52.png?v=1790740582',
                            text:'Cig-Like & Alternative',
                            active:false,
                            childItem:{
                                title:'What matters most to you?',
                                item:[
                                    {
                                        text:'Long Battery<br> & Cig-Like Feel',
                                        active:false
                                    },
                                    {
                                        text:'Compact<br> Cig-Like Feel',
                                        active:false
                                    },
                                    {
                                        text:'Tobacco<br> Experience',
                                        active:false
                                    }
                                ]
                            }
                        }
                    ]
                }
            ],
            resData:[
                {
                    item:[
                        {
                            child:[
                                {
                                    title:'XLIM PRO 3',
                                    url:'/xlim-pro-3',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/PRO_3.avif?v=1773279727'
                                },
                                {
                                    title:'XLIM PRO 2',
                                    url:'/xlim-pro-2',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/pro_2.avif?v=1773283483'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'XLIM PRO 4',
                                    url:'/xlim-pro-4',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/a3ff7d74c95d830d07fd49c6ea48b2d2_fa5205af-9477-4700-a0d3-8ed177b0d113.avif?v=1791941548'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'XLIM 4',
                                    url:'/xlim-4',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/a3ff7d74c95d830d07fd49c6ea48b2d2_d4417f6f-4437-4b70-81c4-5cb67c37481e.avif?v=1790741747'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'XLIM 3 ULTRA',
                                    url:'/xlim-3-ultra',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ULTRA.avif?v=1773283483'
                                },
                                {
                                    title:'XLIM SQ PRO 2',
                                    url:'/xlim-sq-pro-2',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SQ_PRO_2.avif?v=1773283484'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'XLIM PRO 2 DNA Version',
                                    url:'/xlim-pro-2-dna',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/DNA_6c271d57-2846-413a-a6f4-7664b842aac5.avif?v=1773283483'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'UNIONE',
                                    url:'/unione',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/UNIONE_67122f58-3d56-4400-8773-53ba24daf46e.avif?v=1779070771'
                                }
                            ]
                        }
                    ]
                },
                {
                    item:[
                        {
                            child:[
                                {
                                    title:'XLIM GO 2',
                                    url:'/xlim-go-2',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/GO_2.avif?v=1773283483'
                                },
                                {
                                    title:'XLIM GO',
                                    url:'/xlim-go',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/go.avif?v=1773283483'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'XLIM GO LITE',
                                    url:'/xlim-go-lite',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/XLIM_GO_LITE_f2263e98-fa2a-48e5-94dd-5e1337c41e66.avif?v=1776158635'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'NeXLIM GO',
                                    url:'/nexlim-go',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_GO_0e4c6aad-a42b-4668-bcd7-2ae392c8b823.avif?v=1773283483'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'NeXLIM 2 MINI',
                                    url:'/nexlim-2-mini',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM-2-MINI.avif?v=1783409004'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'SLIMSTICK X',
                                    url:'/slimstick-x',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLImSTICK_x_8ac725a0-feb6-4d8c-953e-eb316f95a510.avif?v=1773283483'
                                }
                            ]
                        }
                    ]
                },
                {
                    item:[
                        {
                            child:[
                                {
                                    title:'NeXLIM 2',
                                    url:'/nexlim-2',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM-2.avif?v=1783409004'
                                },
                                {
                                    title:'NeXLIM',
                                    url:'/nexlim',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/NeXLIM_fcc7b21a-5b90-4562-a42c-08b3ccafbd95.avif?v=1773283483'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'VPRIME 2',
                                    url:'/vprime-2',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/a3ff7d74c95d830d07fd49c6ea48b2d2.avif?v=1789032911'
                                },
                                {
                                    title:'VPRIME',
                                    url:'/vprime',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/VPRIME_a60e8e7a-7999-4062-965b-05a39a0bdddb.avif?v=1773283483'
                                }
                            ]
                        }
                    ]
                },
                {
                    item:[
                        {
                            child:[
                                {
                                    title:'SLIMSTICK',
                                    url:'/slimstick',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/SLImSTICK_778edbf7-ae7d-46fa-beeb-16ff6e9977d6.avif?v=1773283483'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'SLIMSTICK NANO',
                                    url:'/slimstick-nano',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/a3ff7d74c95d830d07fd49c6ea48b2d2_abf2b05e-cb7e-4840-ac23-e730e664f5d0.avif?v=1789436658'
                                }
                            ]
                        },
                        {
                            child:[
                                {
                                    title:'ARTIO 2',
                                    url:'/artio-2',
                                    img:'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ARTIO_2_858224f4-91ef-4d4d-9420-99e39286466f.avif?v=1773283483'
                                }
                            ]
                        }
                    ]
                }
            ],
            bestTitle:'',
            showFlag:false,
            cardFlag:false,
            resStr:''
        }
    },
    methods:{
        startOver(){
            this.showFlag = false
            this.navIndex = 0
            this.childIndex = 0
            this.lastIndex = 0
            this.bestTitle = ''
            this.resStr = ''

            // Clear all previous selections, including nested selections.
            this.selectData.forEach(group => {
                group.item.forEach(item => {
                    item.active = false

                    if(item.childItem && item.childItem.item){
                        item.childItem.item.forEach(child => {
                            child.active = false
                        })
                    }
                })
            })

            if(box2SwiperInstance){
                box2SwiperInstance.slideTo(0, 0)
            }
        },
        showRes(){
            const childItems = this.selectData[2].item[this.childIndex].childItem.item
            const selectedIndex = childItems.findIndex(item => item.active)

            // Do not calculate a result until question 4 has a valid answer.
            if(selectedIndex === -1){
                return
            }

            this.lastIndex = selectedIndex

            const resultItem = this.resData[this.childIndex]
                && this.resData[this.childIndex].item[this.lastIndex]
            const matches = resultItem && resultItem.child

            if(!matches || !matches.length){
                return
            }

            this.bestTitle = matches[0].title
            this.showFlag = true

            this.$nextTick(() => {
                if(box2SwiperInstance){
                    box2SwiperInstance.update()
                    box2SwiperInstance.slideTo(0, 0)
                }
            })

            this.sendData()
        },
        async sendData(){
            const stripHTML = (str) => str.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

            this.resStr = this.selectData.reduce((str, group) => {
            const activeItem = group.item.find(item => item.active);

            if (activeItem) {
                str += (str ? ' / ' : '') + stripHTML(activeItem.text);

                const activeChild = activeItem.childItem?.item.find(child => child.active);
                if (activeChild) {
                str += ' / ' + stripHTML(activeChild.text);
                }
            }

            return str;
            }, '');

            this.resStr += (this.resStr ? ' / ' : '') + this.bestTitle;

            let params=new URLSearchParams();
            params.append('info',this.resStr);
            await axios.post('https://service.oxvatech.cn/OXVA/product_finder',params);
        },
        nextItem(){
            if(this.selectData[this.navIndex].item.some(item => item.active === true)){
                this.navIndex++
            }
        },
        backItem(){
            if(this.navIndex > 0){
                this.navIndex--
            }else{
                this.cardFlag = false
            }
        },
        selectItem(index,type){
            if(type==1){
                if(!this.selectData[this.navIndex].item[index].active){
                    this.selectData[this.navIndex].item.forEach((item,i)=> item.active = i === index)

                    if(this.navIndex==2){
                        // Reset the old fourth-question index before switching branch.
                        // Otherwise the hidden result block can evaluate an out-of-range
                        // resData[childIndex].item[lastIndex].
                        this.lastIndex = 0

                        // Clear nested answers from every branch.
                        this.selectData[2].item.forEach(item => {
                            item.childItem.item.forEach(child => {
                                child.active = false
                            })
                        })

                        this.childIndex=index
                    }
                }
            }else{
                if(!this.selectData[2].item[this.childIndex].childItem.item[index].active){
                    this.selectData[2].item[this.childIndex].childItem.item.forEach((item,i)=> item.active = i === index)
                    this.lastIndex=index
                }
            }

        },
        getBoxClass() {
            let num
            //console.log(this.childIndex)
            if(this.childIndex === 0){
                num = 6
            }else if(this.childIndex === 1){
                num = 6
            }else if(this.childIndex === 2){
                num = 1
            }else if(this.childIndex === 3){
                num = 2
            }
            return 'box2_i' + num
        }
    },
    mounted(){
        var that = this
        box2SwiperInstance = new Swiper('.box2Swiper', {
            slidesPerView: wFlag?3:2,
            centeredSlides: true,
            slideToClickedSlide: true,
            on:{
                slideChange: function(){
                    const resultItem = that.resData[that.childIndex]
                        && that.resData[that.childIndex].item[that.lastIndex]
                    const matches = resultItem && resultItem.child

                    if(matches && matches[this.activeIndex]){
                        that.bestTitle = matches[this.activeIndex].title
                    }
                },
            },
        })
    }
})